import type { RefObject } from "react";
import { Box } from "@mui/material";
import { AssetMap } from "../../../components/common/maps";
import Assets from "../../assets/Assets";
import type { Accordion, Asset, Country, Sector } from "../../../types/deal";

type DealAssetsTabProps = {
  dealId: number;
  assetsRef: RefObject<HTMLDivElement | null>;
  assets: Asset[];
  accordions: Accordion[];
  dealMapInfo: {
    sectors: Sector[];
    countries: Country[];
  };
  mapFullscreenOpen: boolean;
  setMapFullscreenOpen: (open: boolean) => void;
};

export function DealAssetsTab({
  dealId,
  assetsRef,
  assets,
  accordions,
  dealMapInfo,
  mapFullscreenOpen,
  setMapFullscreenOpen,
}: DealAssetsTabProps) {
  return (
    <Box ref={assetsRef} sx={{ mt: 0 }}>
      <Box sx={{ position: "relative" }}>
        <AssetMap
          assets={assets}
          accordions={accordions}
          dealMapInfo={dealMapInfo}
          setMapFullscreenOpen={setMapFullscreenOpen}
          mapFullscreenOpen={mapFullscreenOpen}
        />
      </Box>

      <Box
        sx={{
          mt: 2,
          height: 420,
          minHeight: 0,
          width: "100%",
          overflow: "hidden",
        }}
      >
        <Box sx={{ height: "100%", minHeight: 0, overflow: "auto" }}>
          <Assets dealId={dealId} accordionValues={accordions} />
        </Box>
      </Box>
    </Box>
  );
}
